// extracted by mini-css-extract-plugin
module.exports = {"view":"Calendar_view__2CHaA","header":"Calendar_header__2niU5","calendar":"Calendar_calendar__20TvM"};